import React from 'react';
import { Code2, Cloud, Shield, Smartphone, Monitor, Palette } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function Services() {
  const { data } = useLanguage();
  const servicesData = data.ourservice;

  if (!servicesData.active) return null;

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">{servicesData.title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8">
          {servicesData.nodes.map((service) => (
            <div
              key={service.id}
              className="p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all text-center group"
            >
              <div className="mb-4 flex justify-center">
                {service.icon ? (
                  <div className="text-6xl mb-2 transform hover:scale-110 transition-transform duration-300">
                    {service.icon}
                  </div>
                ) : service.image ? (
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                ) : (
                  <div className="text-blue-600">
                    {service.id === 1 && <Code2 className="w-12 h-12" />}
                    {service.id === 2 && <Smartphone className="w-12 h-12" />}
                    {service.id === 3 && <Palette className="w-12 h-12" />}
                    {service.id >= 4 && <Monitor className="w-12 h-12" />}
                  </div>
                )}
              </div>
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}